var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { targetTenantCheck } from '@/common/api/common';
import { isNotEmptyAny } from '@lhb/func';
export default {
    state: {
        scoreDetail: null,
        createdFranchiseeId: null,
        searchSelected: null,
        poiSelected: null,
        isSearchConfirmBack: null,
        position: null,
        tenantCheck: null,
        chancepointnameManualEdited: false,
    },
    actions: {
        /**
         * 获取租户配置信息
         */
        $_GetTenantCheck: function (_a) {
            var commit = _a.commit, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!isNotEmptyAny(state.tenantCheck)) return [3 /*break*/, 2];
                            return [4 /*yield*/, targetTenantCheck()];
                        case 1:
                            data = (_b.sent()).data;
                            commit('updateTenantCheck', data);
                            return [2 /*return*/, data];
                        case 2: return [2 /*return*/, state.tenantCheck || {}];
                    }
                });
            });
        },
    },
    mutations: {
        UPDATETENANTCHECK: function (state, val) {
            state.tenantCheck = val;
        },
        SCORE_DETAIL: function (state, val) {
            state.scoreDetail = val;
        },
        STANDARDSTORE_FRANCHISEEID: function (state, val) {
            state.createdFranchiseeId = val;
        },
        STANDARDSTORE_POSITION: function (state, val) {
            state.position = val;
        },
        STANDARDSTORE_SEARCH_SELECTED: function (state, val) {
            state.searchSelected = val;
        },
        STANDARDSTORE_POI_SELECTED: function (state, val) {
            state.poiSelected = val;
        },
        STANDARDSTORE_SEARCH_POI_CONFIRMED: function (state, val) {
            state.isSearchConfirmBack = val;
        },
        CHANCEPOINTNAME_MANUALEDITED: function (state, val) {
            state.chancepointnameManualEdited = val;
        },
    },
    getters: {}
};
